export enum Flags {
  DischargeQuestions = 'discharge_questions',
  AltcsPending = 'altcs_pending',
  ComparisonForAiSummary = 'comparison_for_ai_summary',
  InboundReferrals = 'inbound_referrals',
  InboundReferralNotifications = 'inbound_referral_notifications',
  InAppNotifications = 'in_app_notifications',
  PushNotifications = 'push_notifications',
  PreferredProviders = 'preferred_providers',
  FacilityInOutOfNetworkDesignation = 'facility_in_out_of_network_designation',
  SftpUserSelfService = 'sftp_user_self_service',
}
